import React from 'react';
import { connect } from 'react-redux';
import { compose, setDisplayName, branch, renderNothing } from 'recompose';
import styles from './FormTypeSelection.scss';

const FormTypeSelection = ({ selected }) => {
  const selectSubscription = selected.voucherCode ? { selectedOption: selected } : { id: selected.id };
  const backFromLoginUrl = `${window.location.origin}/subscriptions/payment/#state=${btoa(JSON.stringify(selectSubscription))}`;
  const authUrl = `${window.location.origin}/api/auth/login/?state=${btoa(backFromLoginUrl)}&force=true`;

  return (
    <div className={styles.root}>
      <a href={authUrl} className={`ui-btn ui-btn_secondary ${styles.button} ${styles.login}`}>
        Log in
      </a>
      <a href={`${authUrl}&signup=true`} className={`ui-btn ui-btn_primary ${styles.button} ${styles.register}`}>
        Sign Up
      </a>
    </div>
  );
};


export default compose(
  setDisplayName('FormTypeSelectionOutter'),
  connect(({ subscriptions: { selected }, userInfo, auth: { sessionStatus } }) => ({ selected, userInfo, sessionStatus })),
  branch(
    props => props.userInfo.data !== null && props.sessionStatus,
    renderNothing,
  ),
)(FormTypeSelection);
